import { Landmark, Building2, Umbrella, Cpu, Banknote, CircuitBoard } from "lucide-react";
import { PageHero, SectionHead, Reveal, Card, usePageMeta } from "@/components/primitives";
import EnquiryForm from "@/components/EnquiryForm";
import { PARTNER_CATEGORIES } from "@/lib/data";

const ICONS = { Landmark, Building2, Umbrella, Cpu, Banknote, CircuitBoard };

export default function Partners() {
  usePageMeta(
    "TimePe Partners | Build the Future of Financial Access Together",
    "Partner with TimePe across banking, NBFC, insurance, FinTech, payments, technology and institutional categories."
  );
  return (
    <>
      <PageHero
        eyebrow="Partners"
        lines={["Let's Build the Future of", "Financial Access Together."]}
        lead="TimePe is designed to be built with the ecosystem, not around it. If you operate in Indian financial services, there's a place to build with us."
      />

      <section className="border-b border-line py-24 sm:py-32" data-testid="partner-categories">
        <div className="mx-auto max-w-[1440px] px-6 lg:px-8">
          <SectionHead eyebrow="Partnership Categories" title="Where We Build Together" />
          <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {PARTNER_CATEGORIES.map((c, i) => {
              const Icon = ICONS[c.icon];
              return (
                <Reveal key={c.title} delay={i * 0.05} className={i === 6 ? "lg:col-span-3 lg:max-w-[calc(33.333%-0.75rem)]" : ""}>
                  <Card testid={`partner-category-${i}`} className="group h-full p-7">
                    <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-line bg-abyss text-electric transition-colors duration-300 group-hover:border-electric/50">
                      <Icon className="h-5 w-5" />
                    </span>
                    <h3 className="mt-5 font-display text-lg font-semibold text-mist">{c.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-mute">{c.body}</p>
                  </Card>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-24 sm:py-32" data-testid="partner-form-section">
        <div className="mx-auto max-w-4xl px-6">
          <SectionHead eyebrow="Become a TimePe Partner" title="Start the Conversation" className="mb-12" center />
          <EnquiryForm
            defaultInterest="Partnership"
            source="partners-page"
            heading="Partnership Enquiry"
            lead="Tell us about your organisation and how you'd like to build with TimePe. Every enquiry lands directly with our team."
            testid="partner-enquiry"
          />
        </div>
      </section>
    </>
  );
}
